import ManualLayout from '../components/ManualLayout';

interface ManualIndexPageProps {
  language: 'ja' | 'en';
  onLanguageChange: (lang: 'ja' | 'en') => void;
}

export default function ManualIndexPage({ language, onLanguageChange }: ManualIndexPageProps) {
  return (
    <ManualLayout currentPath="/manual" language={language} onLanguageChange={onLanguageChange}>
      <div className="manual-welcome">
        <img
          src="/exworks-manual.png"
          alt="ExWorks Manual"
          className="manual-welcome-logo"
        />
        <h1 className="manual-welcome-title">
          {language === 'en'
            ? 'Trading Playground - No-Code EA Builder'
            : 'Trading Playground - ノーコード自動売買ビルダー'}
        </h1>
        <p className="manual-welcome-description">
          {language === 'en'
            ? 'Learn how to use Trading Playground, organized by section.'
            : 'Trading Playgroundの使い方をセクションごとに解説します。'}
        </p>
      </div>
    </ManualLayout>
  );
}
